interface TaskLinkVals {
  linked_object_id: string;
  linked_deliverable_id: string;
  linked_asset_id: string;
}

export const TaskLinker = {
  getVals(mode: string): TaskLinkVals {
    // Safe casting and element retrieval
    const typeSelect = document.getElementById(
      "link-type-select_" + mode,
    ) as HTMLSelectElement | null;
    if (!typeSelect)
      return { linked_object_id: "", linked_deliverable_id: "", linked_asset_id: "" };

    const type = typeSelect.value;
    const prefix = "linked_" + type + "_id_" + mode;
    const el = document.getElementById(prefix) as HTMLInputElement | HTMLSelectElement | null;
    const val = el ? el.value : "";

    return {
      linked_object_id: type === "object" ? val : "",
      linked_deliverable_id: type === "deliverable" ? val : "",
      linked_asset_id: type === "asset" ? val : "",
    };
  },

  resetPending() {
    // Dispatch event to Alpine components
    window.dispatchEvent(new CustomEvent("task-linker-reset"));
  },
};
